import React from 'react';
import { Star, Quote } from 'lucide-react';

const ShopwareTestimonials = () => {
  const testimonials = [
    {
      name: "Thomas Müller",
      position: "Geschäftsführer",
      company: "TechTrade GmbH",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      quote: "Wir haben unseren B2B-Shop von S+D Solutions entwickeln lassen und sind begeistert. Die Shopware-Integration mit unserem ERP-System funktioniert einwandfrei und der Shop hat unsere Erwartungen übertroffen. Die Conversion-Rate ist um 53% gestiegen!",
      stars: 5,
      shopType: "B2B Shop"
    },
    {
      name: "Sarah Becker",
      position: "Marketing Leiterin",
      company: "Style & Fashion",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      quote: "Nach mehreren Fehlversuchen mit anderen Agenturen haben wir endlich den richtigen Partner gefunden. Unser Shopware-Shop ist nicht nur optisch ein Highlight, sondern überzeugt auch technisch auf ganzer Linie. Die Verkaufszahlen sprechen für sich!",
      stars: 5,
      shopType: "B2C Shop"
    },
    {
      name: "Michael Weber",
      position: "E-Commerce Manager",
      company: "Industrial Solutions AG",
      image: "https://randomuser.me/api/portraits/men/64.jpg",
      quote: "Die Komplexität unserer B2B-Anforderungen hat viele Agenturen abgeschreckt. S+D Solutions hat nicht nur alle Herausforderungen gemeistert, sondern auch noch wertvolle Verbesserungsvorschläge eingebracht. Top Shopware-Expertise!",
      stars: 5,
      shopType: "B2B Portal"
    }
  ];

  const renderStars = (count) => {
    return Array(count)
      .fill(0)
      .map((_, i) => (
        <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
      ));
  };

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-white">
      <div className="container">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
            Zufriedene Kunden
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Das sagen unsere Kunden über ihre Shopware-Shops
          </h2>
          
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir haben bereits zahlreiche Shopware-Shops programmiert und unsere Kunden mit 
            maßgeschneiderten Lösungen begeistert. Überzeuge dich selbst!
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 h-3"></div>
              
              <div className="p-6 md:p-8">
                <div className="flex justify-between items-start mb-6">
                  <div className="flex gap-4">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name} 
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div>
                      <h3 className="font-bold text-lg">{testimonial.name}</h3>
                      <p className="text-gray-600 text-sm">{testimonial.position}</p>
                      <p className="text-gray-700 font-medium">{testimonial.company}</p>
                    </div>
                  </div>
                  
                  <div className="bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full">
                    {testimonial.shopType}
                  </div>
                </div>
                
                <div className="mb-4 flex">
                  {renderStars(testimonial.stars)}
                </div>
                
                <div className="relative">
                  <Quote className="absolute top-0 left-0 h-6 w-6 text-blue-200 -translate-x-2 -translate-y-2" />
                  <p className="text-gray-600 relative z-10 pl-3">{testimonial.quote}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">Tritt der wachsenden Anzahl zufriedener Shopware-Kunden bei</p>
          <div className="flex justify-center gap-x-8 gap-y-4 flex-wrap">
            <img 
              src="https://via.placeholder.com/120x40?text=Logo+1" 
              alt="Kundenlogo"
              className="h-10 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all"
            />
            <img 
              src="https://via.placeholder.com/120x40?text=Logo+2" 
              alt="Kundenlogo"
              className="h-10 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all"
            />
            <img 
              src="https://via.placeholder.com/120x40?text=Logo+3" 
              alt="Kundenlogo"
              className="h-10 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all"
            />
            <img 
              src="https://via.placeholder.com/120x40?text=Logo+4" 
              alt="Kundenlogo"
              className="h-10 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all"
            />
            <img 
              src="https://via.placeholder.com/120x40?text=Logo+5" 
              alt="Kundenlogo"
              className="h-10 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopwareTestimonials; 